import { UpdateProfileForm } from "../../forms/UpdateProfileForm";

export const ProfileUpdateCard: React.FC = () => {
    return (
        <div className="relative bg-white rounded-md p-8">
            <h2 className="font-medium text-xl lg:text-2xl mb-4">My Details</h2>
            <UpdateProfileForm />
        </div>
    );
};